import { mapState, mapActions } from 'vuex';

import { generateArrayFromString } from '@helpers';

export default {
  name: 'JobsSync',
  data() {
    return {
      days: 1,
      vendor: '',
      idsStr: '',
      dialog: false,
      syncByIds: false,
    };
  },
  computed: {
    ...mapState('locations', {
      vendors: ({ locations, suffix: currentSuffix }) => {
        const { vendors } = locations.find(({ suffix }) => suffix === currentSuffix) || {};
        return (vendors || []).map(vendor => ({ value: vendor, text: vendor }));
      },
    }),
    daysErrorConfig() {
      const messages = [];
      let error = false;
      if (!`${this.days}`.length) {
        error = true;
        messages.push('Required field');
      } else if (this.days < 1) {
        error = true;
        messages.push('Value must be positive');
      }
      return { error, messages };
    },
    idsArr() {
      return generateArrayFromString(this.idsStr);
    },
    idsErrorConfig() {
      const messages = [];
      let error = false;
      if (!this.idsArr.length) {
        error = true;
        messages.push('Required field');
      }
      return { error, messages };
    },
    isInvalidForm() {
      return this.syncByIds
        ? this.idsErrorConfig.error
        : this.daysErrorConfig.error
        || !this.vendor;
    },
  },
  watch: {
    syncByIds(newValue) {
      if (newValue) {
        this.idsStr = '';
      } else {
        this.days = 1;
      }
    },
    vendors: {
      handler(newValue) {
        const [vendor] = newValue;

        if (vendor) {
          this.vendor = vendor.value;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions('jobs', ['syncAllJobs', 'syncJobsByIds']),
    submit() {
      if (this.isInvalidForm) {
        return;
      }

      this.$VBlackerTheme.alert.warning({
        text: 'Sync jobs?',
      }, async () => {
        this.$VBlackerTheme.openLoadingSpinner();
        try {
          await this[this.syncByIds ? 'syncJobsByIds' : 'syncAllJobs']({
            vendor: this.vendor, days: this.days, ids: this.idsArr,
          });
          this.$emit('success');
          this.dialog = false;
          this.resetFormData();
        } catch (e) {
          this.$VBlackerTheme.notification.error(e);
        } finally {
          this.$VBlackerTheme.closeLoadingSpinner();
        }
      });
    },
    resetFormData() {
      this.days = 1;
    },
  },
};
